import * as serviceWorkerRegistration from './src/serviceWorkerRegistration';
require('./app.web.js');

if (!__DEV__) {
  serviceWorkerRegistration.register();
}
